import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { DataFilterAutocompleteComponent } from './data-filter-autocomplete.component';

@Component({
  selector: 'app-data-filter-form-autocomplete',
  templateUrl: './data-filter-autocomplete.component.html',
  styleUrls: ['./data-filter-autocomplete.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class DataFilterFormAutocompleteComponent extends DataFilterAutocompleteComponent implements OnInit, OnChanges {
  ngOnInit() {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }
}

